/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Theme from 'embercom/objects/inbox/types/theme';
import type ThemeService from 'embercom/services/theme-service';
export default class CopilotFrameController extends Controller {
  @service declare themeService: ThemeService;

  queryParams = ['external_id', 'external_type', 'theme'];

  external_id = null;
  external_type = null;
  theme = null;

  get isDarkTheme() {
    return this.themeService.theme === Theme.Dark;
  }

  get isZendesk() {
    return this.external_type === 'ZENDESK_TICKET';
  }

  @action updateParams(paramName: string, paramValue: string) {
    this.set(paramName as keyof this, paramValue);
  }
}
